import { Good } from "@/entities/good";
import { geniFetch } from "./geniBackend";

export const setWbGoodId = async (good: Good, id: string, nmId: number | null = null) => {
  good.publicationData.wb = good.publicationData.wb || {};
  good.publicationData.wb.id = id;

  await geniFetch(`/goods/${good.id}`, {
    method: "PATCH",
    body: JSON.stringify({
      metadata: {
        wb: {
          id,
          nmId,
          subjectId: good.publicationData.wb.subjectId,
        },
      },
    }),
  });
};
